<script setup>
import { computed, defineExpose, defineProps, ref } from 'vue';
import { useLoadingCheck, useModifiers } from '@/app/composables/';

const props = defineProps({
  disabled: {
    required: false,
    default: () => false,
    type: Boolean,
  },
  icon: {
    required: false,
    type: String,
  },
  modifiers: {
    default: () => [],
    required: false,
    type: Array,
  },
  type: {
    required: true,
    type: String,
  },
});
const cssClasses = computed(() => useModifiers('c-button', props.modifiers));
const { loadingPrevent, loadingTabindex } = useLoadingCheck();
const focusEl = ref(null);
defineExpose({ focusEl });
</script>

<template>
  <button
    v-bind="$attrs"
    @keydown="loadingPrevent"
    :class="cssClasses"
    :type="type"
    :disabled="disabled"
    :tabindex="loadingTabindex"
    ref="focusEl"
  >
    <slot />
    <svg v-if="icon" class="c-button__icon" aria-hidden="true" focusable="false">
      <use xmlns:xlink="http://www.w3.org/1999/xlink" :xlink:href="icon" />
    </svg>
  </button>
</template>
